module.exports = __webpack_public_path__ + "static/login_vector-bg-9172d75e1b7dbc25b74042d7b9385b1b.png";